import React, { useEffect, useState } from "react";
import "./UsersPage.css";

import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function UsersPage() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));

      const usersArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUsers(usersArray);
    };

    fetchUsers();
  }, []);

  return (
    <section className="usersPage">
      <h1>Users Detail</h1>
      <hr />

      <div className="tableWrapper">
        <table className="userTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Cart Count</th>
              <th>Cart Items</th>
            </tr>
          </thead>

          <tbody>
            {users.map((v) => (
              <tr key={v.id}>
                <td>{v.name}</td>
                <td>{v.email}</td>

                <td>
                  {v.cart?.length > 0 ? v.cart.length + " items" : "No Items"}
                </td>
                <td>
                  {v.cart?.map((item) => (
                    <div key={item.id}>
                      {item.name} ({item.qty})
                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
